import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Download, FileText, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import WizardLayout from '@/components/wizard/WizardLayout';
import { toast } from 'sonner';

const WizardCompletion = () => {
  const navigate = useNavigate();
  const [jobDetails, setJobDetails] = useState(null);

  useEffect(() => {
    const converterData = JSON.parse(sessionStorage.getItem('ixbrl_converter') || '{}');
    if (!converterData.jobId || !converterData.ixbrlData) {
      toast.error('Session expired');
      navigate('/jobs');
      return;
    }

    setJobDetails(converterData);
  }, [navigate]);

  const handleDownload = (format) => {
    toast.success(`Downloading ${format} file...`);
  };

  if (!jobDetails) return null;

  return (
    <WizardLayout currentStep={4} title="Conversion Complete" company={jobDetails.company}>
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle2 className="w-10 h-10 text-green-600" />
          </div>
          <h2 className="text-2xl font-semibold mb-2">Conversion Successful!</h2>
          <p className="text-muted-foreground">Your document has been converted to iXBRL format</p>
        </div>

        <div className="bg-muted border border-border rounded-lg p-6 mb-8">
          <div className="flex items-center justify-center gap-12">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Job ID</p>
              <p className="text-lg font-mono font-medium">{jobDetails.jobId}</p>
            </div>
            <div className="w-px h-12 bg-border"></div>
            <div>
              <p className="text-sm text-muted-foreground mb-1">Tags Created</p>
              <p className="text-lg font-mono font-medium">{jobDetails.ixbrlData.length}</p>
            </div>
          </div>
        </div>

        <div className="space-y-3 mb-8">
          <p className="text-sm font-medium text-muted-foreground text-left">DOWNLOAD OPTIONS</p>
          
          <button onClick={() => handleDownload('XHTML')} className="w-full border border-border rounded-lg p-4 hover:bg-accent transition-colors text-left flex items-center justify-between group">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 border border-border rounded-lg bg-muted group-hover:bg-background flex items-center justify-center">
                <FileText className="w-6 h-6" />
              </div>
              <div>
                <p className="font-medium">iXBRL (XHTML)</p>
                <p className="text-sm text-muted-foreground">Standard format for HMRC</p>
              </div>
            </div>
            <Download className="w-5 h-5 text-muted-foreground" />
          </button>

          <button onClick={() => handleDownload('JSON')} className="w-full border border-border rounded-lg p-4 hover:bg-accent transition-colors text-left flex items-center justify-between group">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 border border-border rounded-lg bg-muted group-hover:bg-background flex items-center justify-center">
                <FileText className="w-6 h-6" />
              </div>
              <div>
                <p className="font-medium">JSON Export</p>
                <p className="text-sm text-muted-foreground">Machine-readable format</p>
              </div>
            </div>
            <Download className="w-5 h-5 text-muted-foreground" />
          </button>
        </div>

        <div className="flex gap-4 justify-center">
          <Button variant="outline" onClick={() => { sessionStorage.removeItem('ixbrl_converter'); navigate('/'); }}>
            <Home className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
          <Button onClick={() => { sessionStorage.removeItem('ixbrl_converter'); navigate('/wizard/start'); }}>
            Start New Job
          </Button>
        </div>
      </div>
    </WizardLayout>
  );
};

export default WizardCompletion;